
import { debounce } from '@/assets/script/utils/index.js'

export default {
  name: 'Input',
  data: () => ({
    params: '',
    debouncedCallback: undefined,
  }),
  watch: {
    params(val) {
      this.debouncedCallback(val)
    },
  },
  mounted() {
    this.debouncedCallback = debounce((val) => {
      this.$emit('search', val)
    }, 750)
  },
}
